import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { log } from 'console';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
    'Access-Control-Allow-Credentials': 'true',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UmsService {
  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService,

  ) {
    this.APIService = environment.serviceUrl;
    // this.secretdata = this.secretdata;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });

  }
  private tclcData: any;

  setTclcData(data: any) {
    this.tclcData = data;
  }

  getTclcData() {
    return this.tclcData;
  }
  private history: string[] = [];
  public secretdata = [];
  public secretA = [];
  public secretB = [];
  public courseData = [];
  public examData = [];
  public examstrData = [];
  public disable2: Boolean = true;
  public disable4: Boolean = true;
  public disable5: Boolean = true;
  public disable6: Boolean = true;
  public disable7: Boolean = true;
  public profileIcon2: any;
  sortColumn
  sortDirection
  private APIService: string = environment.serviceUrl; // this has to be load from an external config file

  Exam;
  Semester;
  private sharedData: string;
  //sort working only up n down not apl
  // sortData(data: any[], column: string): any[] {
  //   return data.sort((a, b) => (a[column] > b[column] ? 1 : -1));
  // }

  sortData(data: any[], column: string, ascending: boolean = true): any[] {
    return data.sort((a, b) => {
      if (!a) {
        return 0; // Handle cases where the data is undefined
      }

      if (!b) {
        return 0; // Handle cases where the data is undefined
      }

      if (!a.hasOwnProperty(column)) {
        return 0; // Handle cases where column doesn't exist in object A
      }

      if (!b.hasOwnProperty(column)) {
        return 0; // Handle cases where column doesn't exist in object B
      }

      const valueA = a[column];
      const valueB = b[column];

      if (valueA === undefined || valueB === undefined) {
        return 0; // Handle cases where valueA or valueB is undefined
      }

      // Convert values to strings for consistent comparison
      const stringA = String(valueA);
      const stringB = String(valueB);

      // Use localeCompare for alphanumeric sorting
      const comparison = stringA.localeCompare(stringB, undefined, { numeric: true });

      return ascending ? comparison : -comparison;
    });
  }

  setData(data: string) {
    this.sharedData = data;
  }

  getData(): string {
    return this.sharedData;
  }
  deleteuserroleData(id: any) {
    throw new Error('Method not implemented.');
  }
  getNoimg(e) {
    this.profileIcon2 = e
  }
  openSnackbar(message: string) {
    return this.snackBar.open(message, 'close', {
      verticalPosition: 'top',
      horizontalPosition: 'center',
      duration: 2000,
      panelClass: ['snackbarStyle'],
    });
  }
  private log(message: string) {
    console.log('service log : ' + message);
  }
  public secret(e) {
    // environment.key = e;
    this.secretdata = e;
    console.log('dcsddds', this.secretdata);
    sessionStorage.setItem('sessionId',this.secretdata['SnNo']);
    sessionStorage.setItem('ShortName', this.secretdata['InstituteShortName']);
  }
  public secret2(e) {
    this.secretA = e;
  }
  getsecreat(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/projParam/fetch', payload).pipe();
  }

  ForgetPswd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/forget-password', payload).pipe();
  }

  changePswd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/change-password', payload).pipe();
  }

  getStudentMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/students').pipe();
  }

  getTeachersMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/teachers').pipe();
  }

  getParentsMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/parents').pipe();
  }

  login(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/Adminlogin', payload).pipe();
  }

  SearchCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/SearchCollege/fetch', payload).pipe();
  }

  getCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country/fetch', payload).pipe();
  }

  addCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country', payload).pipe();
  }

  updateCountry(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/country', payload).pipe();
  }

  searchCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country/fetch', payload).pipe();
  }

  deleteCountry(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/country', payload).pipe();
  }

  getState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/state/fetch', payload).pipe();
  }

  addState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/state', payload).pipe();
  }

  updateState(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/state', payload).pipe();
  }

  searchState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/state/fetch', payload).pipe();
  }

  deleteState(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/state', payload).pipe();
  }

  getDivision(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/division/fetch', payload).pipe();
  }

  addDivision(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/division', payload).pipe();
  }

  updateDivision(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/division', payload).pipe();
  }

  searchDivision(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/division/fetch', payload).pipe();
  }

  deleteDivision(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/division', payload).pipe();
  }

  getTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town/fetch', payload).pipe();
  }

  addTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town', payload).pipe();
  }

  updateTown(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/town', payload).pipe();
  }

  searchTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town/fetch', payload).pipe();
  }

  deleteTownnn(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/town', payload).pipe();
  }

  getCollegeType(): Observable<any> {
    return this.http.get(this.APIService + '/masters/college-type').pipe();
  }

  addUserForPermission(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/CreateUser', payload).pipe();
  }

  updateUserForPermission(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/UpdateLoginMaster', payload).pipe();
  }

  addPermission(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/Permission', payload).pipe();
  }

  updatePermission(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/Permission', payload).pipe();
  }

  getPermission(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/Permission/fetch', payload).pipe();
  }

  addFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/faculty', payload).pipe();
  }

  updateFaculty(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/faculty', payload).pipe();
  }

  getFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/faculty/fetch', payload).pipe();
  }

  searchFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/faculty/fetch', payload).pipe();
  }

  getCollegeCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/college-course/fetch', payload).pipe();
  }

  getUserCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToCourse/fetch', payload).pipe();
  }

  getUserExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToExam/fetch', payload).pipe();
  }

  AddUserExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToExam', payload).pipe();
  }

  AddUserCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToCourse', payload).pipe();
  }

  getCoursePattern(): Observable<any> {
    return this.http.get(this.APIService + '/masters/course-pattern').pipe();
  }

  getCourseMedium(): Observable<any> {
    return this.http.get(this.APIService + '/masters/medium').pipe();
  }

  getScaleDown(): Observable<any> {
    return this.http.get(this.APIService + '/masters/course-scale-down').pipe();
  }

  getEvaluation(): Observable<any> {
    return this.http.get(this.APIService + '/masters/evaluation-type').pipe();
  }

  getRules(): Observable<any> {
    return this.http.get(this.APIService + '/masters/course-rules').pipe();
  }
  getCourseLevel(): Observable<any> {
    var payload = {"CdType":"COLSR"}
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  getGradePoints(): Observable<any> {
    return this.http.get(this.APIService + '/masters/grade-point').pipe();
  }

  getGpaMarks(): Observable<any> {
    return this.http.get(this.APIService + '/masters/gpa-mark').pipe();
  }

  getIntegratedCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course/fetch', payload).pipe();
  }

  addInteCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course', payload).pipe();
  }

  addCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code', payload).pipe();
  }

  updateCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/code', payload).pipe();
  }

  getCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code/fetch', payload).pipe();
  }

  searchCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code/fetch', payload).pipe();
  }

  addCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types', payload).pipe();
  }

  updateCodeType(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/code-types', payload).pipe();
  }

  getCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  searchCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  getSubTotal(): Observable<any> {
    return this.http.get(this.APIService + '/masters/special-class-rule').pipe();
  }

  addSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session', payload).pipe();
  }

  updateSession(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/session', payload).pipe();
  }

  getSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/fetch', payload).pipe();
  }

  searchSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/fetch', payload).pipe();
  }

  closeSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/close', payload).pipe();
  }

  ExmSchDD(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examForSh/fetch', payload).pipe();
  }

  addExmSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamSchedule', payload).pipe();
  }

  updateExmSch(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ExamSchedule', payload).pipe();
  }

  getCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseForSchedule/fetch', payload).pipe();
  }

  getCourseSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule/fetch', payload).pipe();
  }

  NewCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get_NewCousreSchedule', payload).pipe();
  }

  fetchSubs(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ExamSubRg/fetch', payload).pipe();
  }

  NewSearchCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get_NewSearchCoEditSchedule', payload).pipe();
  }

  addCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule', payload).pipe();
  }

  updateCoSch(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/CourseSchedule', payload).pipe();
  }

  getExmSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  searchExmSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  addExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam', payload).pipe();
  }

  updateExam(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam', payload).pipe();
  }

  getExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
  }

  searchExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
  }

  deleteExam(payload): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        payload,
      },
    };
    return this.http.post(this.APIService + '/masters/exam', options).pipe();
  }

  updateMappingSubject(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/updateSubMap', payload).pipe();
  }

  addExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  updateExamSub(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  getExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject/fetch', payload).pipe();
  }

  searchExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject/fetch', payload).pipe();
  }

  addExamDiv(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-division', payload).pipe();
  }

  getExamDiv(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-division/fetch', payload).pipe();
  }

  searchExamDiv(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-division/fetch', payload).pipe();
  }

  addExamAggr(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-aggr', payload).pipe();
  }

  getExamAggr(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-aggr/fetch', payload).pipe();
  }

  searchExamAggr(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-aggr/fetch', payload).pipe();
  }

  addExamSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/semester', payload).pipe();
  }

  updateExamSem(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/semester', payload).pipe();
  }

  getExamSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/semester/fetch', payload).pipe();
  }

  addExamHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-head', payload).pipe();
  }

  getMarkList(payload): Observable<any> {
    return this.http.get(this.APIService + '/masters/mark-list-format').pipe();
  }

  getExamHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-head/fetch', payload).pipe();
  }

  addParameter(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/parameters', payload).pipe();
  }

  getParameter(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/parameters/fetch', payload).pipe();
  }

  addSessionClosed(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/close', payload).pipe();
  }

  addIntCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course', payload).pipe();
  }

  getIntCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course/fetch', payload).pipe();
  }

  addUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/user', payload).pipe();
  }

  updateUser(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/user', payload).pipe();
  }

  getUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/user/fetch', payload).pipe();
  }

  searchUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/user/fetch', payload).pipe();
  }

  addCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course', payload).pipe();
  }

  getCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
  }

  updateCourse(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/course', payload).pipe();
  }

  getCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/ScrutinyReportsStatusCount/fetch', payload).pipe();
  }

  getExamStream(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-stream/branch/fetch', payload).pipe();
  }

  addCourseCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/college-course', payload).pipe();
  }

  getFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp', payload).pipe();
  }

  payOfflineFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Offlinepayment', payload).pipe();
  }

  getDataForGridSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/get-subject-mapping', payload).pipe();
  }

  getMapSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/get-for-subject-mapping', payload).pipe();
  }

  submitExamStream(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-stream/branch', payload).pipe();
  }

  updateExamStream(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam-stream/branch', payload).pipe();
  }

  getUserData(id): Observable<any> {
    return this.http.get(this.APIService + '/security/get-login-master/' + id + '/10/1/1').pipe();
  }

  getUsers(PageSize, PageNumber): Observable<any> {
    return this.http.get(this.APIService + '/security/get-login-master/0' + '/' + PageSize + '/' + PageNumber + '/1').pipe();
  }

  getOneUsers(payload): Observable<any> {
    return this.http.get(this.APIService + '/security/get-login-master/' + payload + '/10/1/1').pipe();
  }

  getExamTT(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SearchExamTime/fetch', payload).pipe();
  }

  getExamHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetHolidayDate/fetch', payload).pipe();
  }

  getSearchHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetHolidayDate/fetch', payload).pipe();
  }

  SubmitHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InsertHolidayDate', payload).pipe();
  }

  getExamSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamSchedule/fetch', payload).pipe();
  }

  submitExamTT(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamTime', payload).pipe();
  }

  getInputSearch(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchInSpFlag/fetch', payload).pipe();
  }

  getExmFrmDrpList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamFormDrpList/fetch', payload).pipe();
  }

  ICRMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ICRmarksGenerate', payload).pipe();
  }

  generateExamMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GenEditMarks', payload).pipe();
  }

  SaveExmFrm(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditFormSub', payload).pipe();
  }

  ExmFormSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditFormSub/fetch', payload).pipe();
  }

  EditMarks(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditMarks', payload).pipe();
  }

  validateGeneratedExamMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/VldtEditMarks', payload).pipe();
  }

  fetchGeneratedExamMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditMarks/fetch', payload).pipe();
  }

  ControlLock(payload): Observable<any> {
    return this.http.put(this.APIService + '/lock/EditControlLock', payload).pipe();
  }

  ValidateMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/VldtEditMarks', payload).pipe();
  }

  ChangeMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ChngEditList', payload).pipe();
  }

  getRegnFrmList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnFormEditListCo/fetch', payload).pipe();
  }

  getCentForAll(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchCentForAlloc/fetch', payload).pipe();
  }

  updateCentAll(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/CentreAllo', payload).pipe();
  }

  getNewEmCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/general/NewEmCodes/fetch', payload).pipe();
  }

  updateNewEmCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/general/NewEmCodes', payload).pipe();
  }

  getSessionColgCo(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgMap/fetch', payload).pipe();
  }

  addSessionColgCo(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgMap', payload).pipe();
  }

  addSessionExamStrColgCo(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionExamStrCoColgMap', payload).pipe();
  }

  updateSessionColgCo(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/SessionCoColgMap', payload).pipe();
  }

  searchSessCoColg(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgMaplist/fetch', payload).pipe();
  }

  CheckValidDate(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CheckValidDate/fetch', payload).pipe();
  }

  addSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOff', payload).pipe();
  }

  updateSessionCutOff(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/SessionCoColgCutOff', payload).pipe();
  }

  FeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/FeeDetailsReports/fetch', payload).pipe();
  }

  Feebypass(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/getFeebypass/fetch', payload).pipe();
  }

  searchChoiceSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub/fetch', payload).pipe();
  }

  getChoicesubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceForSub/fetch', payload).pipe();
  }

  getTableDataForChoiceSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub/fetch', payload).pipe();
  }

  addChoiceSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub', payload).pipe();
  }

  createChoiceSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub', payload).pipe();
  }

  updateChoiceSubject(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/ExamChoiceSub', payload).pipe();
  }

  getSecretData(): Observable<any> {
    return this.http.get(this.APIService + '/security/SecreatData').pipe();
  }

  listSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOfflist/fetch', payload).pipe();
  }

  findSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOff/fetch', payload).pipe();
  }

  saveCourseQualiConfig(payload): Observable<any> {
    return this.http.post(this.APIService + '/stuFormSettings/CourseQualiConfig', payload).pipe();
  }

  searchCourseQualification(payload): Observable<any> {
    return this.http.post(this.APIService + '/stuFormSettings/SearchCourseQualiConfig/fetch', payload).pipe();
  }

  getStdSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/stuFormSettings/StuFormDetails/fetch', payload).pipe();
  }

  updateStdSetting(payload): Observable<any> {
    return this.http.put(this.APIService + '/stuFormSettings/StuFormDetails', payload).pipe();
  }

  getExamSubMapFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject-mapping/fetch', payload).pipe();
  }

  getSubjectList(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetsingleRecordEsSubMapG/fetch', payload).pipe();
  }

  getStuAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSet/fetch', payload).pipe();
  }

  getStuIASub(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceIAHead/fetch', payload).pipe();
  }

  
  getThHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/SearchSubHead/fetch', payload).pipe();
  }
// IA Marks //
  getStuIAMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StudentIAMarks/fetch', payload).pipe();
  }

  saveStuIaMarksSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StudentIAMarks', payload).pipe();
  }

  updateStuIaMarksSet(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StudentIAMarks', payload).pipe();
  }

  // IA user access //
  getIaMarksHeadData(payload): Observable<any>{
    return this.http.post(this.APIService + '/security/IAMarksThreshold/fetch', payload).pipe(); 
  }

  saveStuIaMarksThreshold(payload): Observable<any>{
    return this.http.post(this.APIService + '/security/IAMarksThreshold', payload).pipe();
  }

  updateStuIaMarksThreshold(payload): Observable<any>{
    return this.http.put(this.APIService + '/security/IAMarksThreshold', payload).pipe();
  }

  getStuIASubHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceListIAHead/fetch', payload).pipe();
  }

  saveStuIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceIAHead', payload).pipe();
  }

  updateStuIAAtd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceIAHead', payload).pipe();
  }

  saveStuIAAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSettingsIAHead', payload).pipe();
  }

  checkDate(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CheckAdmissionDate/fetch', payload).pipe();
  }

  NewSemStuAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/AttendanceDetailsNewSem/fetch', payload).pipe();
  }

  updateStuIAAtdSet(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceSettingsIAHead', payload).pipe();
  }

  getStuIAAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSetIAHead/fetch', payload).pipe();
  }

  getStuIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceListIAHead/fetch', payload).pipe();
  }

  saveStuAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSet', payload).pipe();
  }

  updateStuAtdSet(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceSet', payload).pipe();
  }

  getExamSubjectListFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMapS/fetch', payload).pipe();
  }

  getExamGroupListFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMapG/fetch', payload).pipe();
  }

  getGetCode(): Observable<any> {
    return this.http.get(this.APIService + '/masters/coty').pipe();
  }

  getSubFlag(): Observable<any> {
    return this.http.get(this.APIService + '/masters/subTotFlag').pipe();
  }

  getCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage/fetch', payload).pipe();
  }

  searchCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage/fetch', payload).pipe();
  }

  addCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage', payload).pipe();
  }

  updateCollege(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/collage', payload).pipe();
  }

  getDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district/fetch', payload).pipe();
  }

  addDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district', payload).pipe();
  }

  updateDistrict(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/district', payload).pipe();
  }

  searchDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district/fetch', payload).pipe();
  }

  deleteDistrict(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/district', payload).pipe();
  }

  getOption(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/EsOptions/fetch', payload).pipe();
  }

  getDefineGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/SearchEsGrades/fetch', payload).pipe();
  }

  addDefineGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GradesPts', payload).pipe();
  }

  updateDefineGrid(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/UpdateEsGrades', payload).pipe();
  }

  getThPr(): Observable<any> {
    return this.http.get(this.APIService + '/masters/ThPr/fetch').pipe();
  }

  getValType(): Observable<any> {
    return this.http.get(this.APIService + '/masters/ValType').pipe();
  }

  getCredit(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CredFrExm/fetch', payload).pipe();
  }

  addExamSubSetup(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  updateExamSubSetup(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  getClass(): Observable<any> {
    return this.http.get(this.APIService + '/masters/special-class-rule').pipe();
  }

  getDistrictWiseTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/DistrictWiseTehsil/fetch', payload).pipe();
  }

  getUserList(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userList/fetch', payload).pipe();
  }

  getStateWiseDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/StateWiseDistrict/fetch', payload).pipe();
  }

  getUserRole(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/searchUserRoleWise', payload).pipe();
  }

  addUserCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToCourse', payload).pipe();
  }

  getSingleRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMap/fetch', payload).pipe();
  }

  getParentRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMapParent/fetch', payload).pipe();
  }

  getSupExamRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  getSupExamInputs(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamShInputs/fetch', payload).pipe();
  }

  submitSupExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examControl', payload).pipe();
  }

  ValidateSCHExamInput(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/VldtSchInput/fetch', payload).pipe();
  }

  getSupCourseRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule/fetch', payload).pipe();
  }

  getSupCourseInputs(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseShInputs/fetch', payload).pipe();
  }

  submitSupCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/courseEditControl', payload).pipe();
  }

  getResultGridList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/resultProcessing', payload).pipe();
  }

  getResultBranchDistrictList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SchStr/fetch', payload).pipe();
  }

  getSupExamEditRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examEditControl/fetch', payload).pipe();
  }

  getSupCourseEditRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/courseEditControl/fetch', payload).pipe();
  }

  submitCode_R_(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcResNew', payload).pipe();
  }

  submitCode_U_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ProcUpdtRes', payload).pipe();
  }

  submitCode_C_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignControlSheet', payload).pipe();
  }

  submitCode_D_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignCodes', payload).pipe();
  }

  submitCode_RP_(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcResNew', payload).pipe();
  }

  submitCode_F_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignMarksFoil', payload).pipe();
  }

  submitCode_O_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignRollNos', payload).pipe();
  }

  scheduleLockInit(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateScheduleLock', payload).pipe();
  }

  ValidateRecordsS(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/VldtProcResult', payload).pipe();
  }

  VldtRecordU(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ProcUpdtRes', payload).pipe();
  }

  VldtRecordRP(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcResNew', payload).pipe();
  }

  submitRegistrationNumberProcess(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcRgNo/fetch', payload).pipe();
  }

  getcourseRegistrationList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CoSchFrRgNo/fetch', payload).pipe();
  }

  getCodeList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GenCent/fetch', payload).pipe();
  }

  UpdateCodeDistrict(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateSpFlag', payload).pipe();
  }

  createGenCent(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GenCent', payload).pipe();
  }

  updateGenCent(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/GenCent', payload).pipe();
  }

  fetchExamForQP(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SearchSchedule/fetch', payload).pipe();
  }

  addQPCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/questionPaper', payload).pipe();
  }

  SearchSTR(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SchStr/fetch', payload).pipe();
  }

  updateQPCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/questionPaper', payload).pipe();
  }

  fetchQPDataForGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/questionPaper/fetch', payload).pipe();
  }

  ValidateSCHInput(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/VldtSchInput/fetch', payload).pipe();
  }

  UpdateSCHInput(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateSchInput', payload).pipe();
  }

  UpdateSCHExamInput(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateSchInput', payload).pipe();
  }

  UpdateSCHExamCenterAllocationInput(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdCentreAlloExam', payload).pipe();
  }
 fetchStudDocumentDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentDocumentRequirements/fetch', payload).pipe();
    }
  fetchCategory(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CasteList/fetch', payload).pipe();
  }

  fetchRegiList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnFormEditListCo/fetch', payload).pipe();
  }

  fetchRegiListForGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnForm/fetch', payload).pipe();
  }

  listofSubjects(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ExamSubRg/fetch', payload).pipe();
  }

  addRegiForm(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnForm', payload).pipe();
  }

  addRegiFormScrutiny(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/NewRegnForms', payload).pipe();
  }

  ScrutinyLock(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CheckScrutinyLock', payload).pipe();
  }

  updateRegiForm(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/RegnForm', payload).pipe();
  }

  validateRegiForm(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditRegnForms', payload).pipe();
  }

  SearchFeeAdm(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp_Adm/fetch', payload).pipe();
  }

  OldReceiptAdm(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/GetStudentOldFeeReceipts/fetch', payload).pipe();
  }

  generateExams(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/genProcNewEf', payload).pipe();
  }

  PutvalidateGeneratedExams(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditExamForms', payload).pipe();
  }

  fetchExamRegList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamFormDrpList/fetch', payload).pipe();
  }

  fetchInputExams(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamForm/fetch', payload).pipe();
  }

  fetchInputExamsValid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditExamForm/fetch', payload).pipe();
  }

  fetchEditMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/getEditMarks/fetch', payload).pipe();
  }

  fetchMarksEntryListForGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditMarks/fetch', payload).pipe();
  }

  addMarksEntry(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditMarks', payload).pipe();
  }

  getCentAll(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchCentreAllo/fetch', payload).pipe();
  }

  addZone(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/zone', payload).pipe();
  }

  fetchZone(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/zone/fetch', payload).pipe();
  }

  updateZone(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/zone', payload).pipe();
  }

  fetchExShedule(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  checkICR(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchInICR', payload).pipe();
  }

  checkForDecimal(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchExmMarksD', payload).pipe();
  }

  SearchResult(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditChResult/fetch', payload).pipe();
  }

  searchExmList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ExamForm/fetch', payload).pipe();
  }

  SearchUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/search_login_master', payload).pipe();
  }

  addResult(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditChResult', payload).pipe();
  }

  updateResult(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditChResult', payload).pipe();
  }

  courseClg(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/stucourseClgMap/fetch', payload).pipe();
  }

  getAssLvl(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AssignRole/fetch', payload).pipe();
  }

  wrongPayFeedetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FetchStudentFeeTemplate/fetch', payload).pipe();
  }

  insertScrFeeTemp(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Insert_AdminChangeFeeTransaction', payload).pipe();
  }

  addAssLvl(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AssignRole', payload).pipe();
  }

  ICRTxt(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ICRMarksTxt', payload).pipe();
  }

  SearchEsGrades(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/SearchEsGrades/fetch', payload).pipe();
  }

  getStdAtdList(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/listfrAttnd', payload).pipe();
  }

  getStdAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance/fetch', payload).pipe();
  }

  saveStdAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance', payload).pipe();
  }

  updateStdAtd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendance', payload).pipe();
  }

  getScrutiny(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchScrutiny/fetch', payload).pipe();
  }

  getAppStu(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchScrutinyFrAttendance/fetch', payload).pipe();
  }

  updateScrutiny(payload): Observable<any> {
    return this.http.put(this.APIService + '/admin/Scrutiny', payload).pipe();
  }

  SearchRegnSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnSub/fetch', payload).pipe();
  }

  SearchExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/FormSub/fetch', payload).pipe();
  }

  SearchRegnExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnExam/fetch', payload).pipe();
  }

  SearchRegn(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnForm/fetch', payload).pipe();
  }

  reportDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportDetails/fetch', payload).pipe();
  }

  SrchCoUpdt(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchCoursesUpdated/fetch', payload).pipe();
  }

  reportData(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportsData', payload).pipe();
  }

  ReportExm(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchSchForRpt/fetch', payload).pipe();
  }

  GetUserWise(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetUserWiseCoColg', payload).pipe();
  }

  reportDetailFt(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportDetails/fetch', payload).pipe();
  }

  reportHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportHeaders/fetch', payload).pipe();
  }

  addRpFt(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportHeaders', payload).pipe();
  }

  fetchHOM(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/HOM/fetch', payload).pipe();
  }

  fetchIntakeFilter(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchIntakeFilter', payload).pipe();
  }

  getScrutinyCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CountScrutiny', payload).pipe();
  }

  fetchPersonalDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/personalDetails/fetch', payload).pipe();
  }

  fetchContactDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/AddressDetails/fetch', payload).pipe();
  }

  fetchReservationDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/Reservation/fetch', payload).pipe();
  }

  fetchQualificationDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/Qualification/fetch', payload).pipe();
  }

  fetchAdditionalDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/AdditionalDetails/fetch', payload).pipe();
  }

  fetchMinority(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/MinorityType/fetch', payload).pipe();
  }

  fetchPhotoSignDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentPhotoAndSign/fetch', payload).pipe();
  }

  fetchAddmissionDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/AdmissionDetails/fetch', payload).pipe();
  }

  fetchDocumentDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StuDocumentUpload/fetch', payload).pipe();
  }

  fetchScrutinyHistory(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/ScrutinyHistory', payload).pipe();
  }

  ScrutinyHistoryTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/ScrutinyHistoryTable/fetch', payload).pipe();
  }

  addFeeHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feehead', payload).pipe();
  }

  updateFeeHead(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/feehead', payload).pipe();
  }

  getFeeHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feehead/fetch', payload).pipe();
  }

  fetchCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  addFeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate', payload).pipe();
  }

  addFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  FeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeeTemplateDetails', payload).pipe();
  }

  RgId(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/getRgDetails/fetch', payload).pipe();
  }

  GetEcId(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetEcIdStud/fetch', payload).pipe();
  }

  fetchLatestEcid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetNextExam/fetch', payload).pipe();
  }

  getFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeesByPass/fetch', payload).pipe();
  }

  addFeeTemplet1(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  fetchCheckFeeMode(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/CheckFeeMode/fetch', payload).pipe();
  }

  saveApplicationDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ApplicationTrackDate', payload).pipe();
  }

  getSearchFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeeDetails', payload).pipe();
  }

  updateFeeTemplet(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/feetemplate', payload).pipe();
  }

  getFeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate/fetch', payload).pipe();
  }

  searchFeeTemplate(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate/fetch', payload).pipe();
  }

  searchFeeHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feehead/fetch', payload).pipe();
  }

  updateFeeTemplet1(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  addFeeTempletMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/templatemapping', payload).pipe();
  }

  updateFeeTempletMapping(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/templatemapping', payload).pipe();
  }

  CheckRollNo(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CheckRollNo/fetch', payload).pipe();
  }

  CheckExamTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CheckExamTimeTable/fetch', payload).pipe();
  }

  getFeeTempletMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/templatemapping/fetch', payload).pipe();
  }

  getDownloadDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentDownloadDocument/fetch', payload).pipe();
  }

  addFeeSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feeset', payload).pipe();
  }

  updateFeeSetting(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/feeset', payload).pipe();
  }

  getFeeSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feeset/fetch', payload).pipe();
  }

  getCollegeBySession(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchIntakeCollege', payload).pipe();
  }

  centPaper(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/centPaperExtr', payload).pipe();
  }

  MarkLRem(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/AMDMarkLRem', payload).pipe();
  }

  AdmitRem(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/AMDAdmitRem', payload).pipe();
  }

  SetReportParam(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SetReportParam', payload).pipe();
  }

  renderReport(payload): Observable<any> {
    return this.http.post('http://umsreportsapidevedition.universus.co.in/api/Reports/UMS/RenderReportV2',payload,{responseType: 'blob'})  
      //return this.http.post('https://ssuhsreports.universus.co.in/api/Reports/UMS/RenderReportV2', payload, { responseType: 'blob' })
  }
 generateQR(payload): Observable<any> {
      return this.http.post(this.APIService + '/abcID/generateQR', { data: payload }).pipe();
    }
  fetchstucourseClgMap(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/stucourseClgMap/fetch', payload).pipe();
  }

  searchFeeTempMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/templatemapping/fetch', payload).pipe();
  }

  searchFeeTempSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feeset/fetch', payload).pipe();
  }

  addStdAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CtStuAtndMaster', payload).pipe();
  }

  updateStdAttendance(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/CtStuAtndMaster', payload).pipe();
  }

  AdmFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/FeePaidDetails/fetch', payload).pipe();
  }

  ExmFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetExamFeePaidDetails/fetch', payload).pipe();
  }

  StuAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance/fetch', payload).pipe();
  }

  StuAttendanceNewSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceNewSem/fetch', payload).pipe();
  }

  getIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttndDetailsIAHead/fetch', payload).pipe();
  }

  EnterStdAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CtStuAtndEntry', payload).pipe();
  }


  updateTable(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/CtStuAtndEntry', payload).pipe();
  }

  getSearchTranscriptFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchTranscriptFeeDetails', payload).pipe();
  }

  searchStudentAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CtStuAtndEntry/fetch', payload).pipe();
  }

  getReportsMenu(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/getRptObj', payload).pipe();
  }

  getExamCollegeForReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Search_ExamCollege', payload).pipe();
  }

  unpaidFeeReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/unpaidFeeReport/fetch', payload).pipe();
  }

  DashBoardCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/dashboardCounts/fetch', payload).pipe();
  }

  CourseColgCounts(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/CourseColgCounts/fetch', payload).pipe();
  }

  StuPerform(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/StudentPerformanceGraph/fetch', payload).pipe();
  }

  GenderCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/DashboardGenderCounts/fetch', payload).pipe();
  }

  CasteCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/DashboardCasteCounts/fetch', payload).pipe();
  }

  AdmissionCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/DashboardCollegeWiseAdmission/fetch', payload).pipe();
  }

  getTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Tehsil/fetch', payload).pipe();
  }

  searchTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Tehsil/fetch', payload).pipe();
  }

  addTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Tehsil', payload).pipe();
  }

  updateTehasil(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/Tehsil', payload).pipe();
  }

  searchCouSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule/fetch', payload).pipe();
  }

  getCountryWiseState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CountryStateWise/fetch', payload).pipe();
  }

  getParentId(payload): Observable<any> {
    return this.http.post(this.APIService + '/stuFormSettings/SetPanelParentList/fetch', payload).pipe();
  }

  getFeecount(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/DashboardFeeAdmDtl/fetch', payload).pipe();
  }

  addUserSubjectMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/MarkEntryMapping', payload).pipe();
  }

  getSubUsermappingList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/MarkEntryMapping', payload).pipe();
  }

  saveStdAtdSetting(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceSet', payload).pipe();
  }

  getStuId(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/personalDetails/fetch', payload).pipe();
  }

  SearchRejectRegn(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/rejectedstudents/fetch', payload).pipe();
  }

  addCastSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CastewiseIntake', payload).pipe();
  }

  updateCastSessionCutOff(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/CastewiseIntake', payload).pipe();
  }


  updatePersonalDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/personalDetails', payload).pipe();
  }

  updateContactDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/AddressDetails', payload).pipe();
  }

  PreviousMarks(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/PreviousMarks', payload).pipe();
  }

  VldtRecordRollNo(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignRollNos', payload).pipe();
  }

  fetchRegNoList(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnForm/fetch', payload).pipe();
  }

  fetchTableDataList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditStatus/fetch', payload).pipe();
  }

  addStudentStatus(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditStatus', payload).pipe();
  }

  updateStudentStatus(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditStatus', payload).pipe();
  }

  SearchScrutinyReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/ScrutinyReports/fetch', payload).pipe();
  }

  getSessionIntakeCutoff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CastewiseIntake/fetch', payload).pipe();
  }

  paymentgateway(payload): Observable<any> {
    return this.http.post(this.APIService + "/fees/payment", payload).pipe();
  }

  fetchIntakeFilterForCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CollegeWiseCourse/fetch', payload).pipe();
  }

  fetchFeeTemp(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp', payload).pipe();
  }

  getSchForUpdtReslist(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getSchForUpdtReslist', payload).pipe();
  }

  DownloadSectionMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/DownloadSectionMarks/fetch', payload).pipe();
  }

  DownloadChangeMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/DownloadChangeMarks/fetch', payload).pipe();
  }

  DownloadMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/DownloadMarksByRollNo/fetch', payload).pipe();
  }

  fetchCourseType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
  }

  GetTclcData(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/tclcData/fetch', payload).pipe();
  }

  ValidateFees(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/ValidateFees/fetch', payload).pipe();
  }

  GetTclc(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/tclcmc/fetch', payload).pipe();
  }
  
  AddCertScr(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CertScrutiny', payload).pipe();
  }

  UpdateTclc(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/tclcmc', payload).pipe();
  }

  GetCertScr(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CertScrutiny/fetch', payload).pipe();
  }

  GetTclcStudents(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/TclcStudents/fetch', payload).pipe();
  }

  getFeeTclc(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetempTclc', payload).pipe();
  }

  offlinePayResponce(payload): Observable<any> {
    return this.http.post(this.APIService + "/fees/Offlinepayment", payload).pipe();
  }

  addComplaint(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievances', payload).pipe();
  }

  updateComplaint(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/Grievances', payload).pipe();
  }

  DistrictWiseCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/DistrictWiseCollege/fetch', payload).pipe();
  }

  getComplaint(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievances/fetch', payload).pipe();
  }

  getDepartment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Departments/fetch', payload).pipe();
  }

  addAction(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Actions', payload).pipe();
  }

  getAction(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Actions/fetch', payload).pipe();
  }
  getComment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Comments/fetch', payload).pipe();
  }
  getActionComment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetGrievance_ActionsAndComments/fetch', payload).pipe();
  }

  addComment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Comments', payload).pipe();
  }

  getApplyData(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/StuAdmFrmDtls/fetch', payload).pipe();
  }

  getCasteData(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CasteMaster/fetch', payload).pipe();
  }

  addCaste(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CasteMaster', payload).pipe();
  }

  updateCaste(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/CasteMaster', payload).pipe();
  }

  getCasteCategoryData(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CasteCategory/fetch', payload).pipe();
  }

  addCasteCategory(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CasteCategory', payload).pipe();
  }

  updateCasteCategory(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/CasteCategory', payload).pipe();
  }

  SearchTranscript(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchTranscript/fecth', payload).pipe();
  }

  GetTcLcDocDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/tclcDocDetails/fetch', payload).pipe();
  }

  payZeroFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/paymentresponse', payload).pipe();
  }

  addGrievanceAssign(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/GrievanceAssign', payload).pipe();
  }

  getFeeResponse(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeeResponse', payload).pipe();
  }

  getGrievanceAssign(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/GrievanceAssign/fetch', payload).pipe();
  }

  getCenterCollegeForReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetCenterWiseAdmit', payload).pipe();
  }

  CommonDocument(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CommonDocumentDetails/fetch', payload).pipe();
  }

  GetTcLcDocUploadDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/tclcDocUploadDetails/fetch', payload).pipe();
  }

  saveDocUploadDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/saveTclcDocUploadDetails', payload).pipe();
  }

  fetchFeeTempTclc(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetempTclc', payload).pipe();
  }

  
  AddWithHold(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExcp', payload).pipe();
  }

  UpdtWithHold(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditExcp', payload).pipe();
  }
  
  VldtWithHold(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditExcp', payload).pipe();
  }

  SearchWithHold(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditExcp/fetch', payload).pipe();
  }

  fetchPackingList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/PackList/fetch', payload).pipe();
  }

  updatePackingList(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/PackList', payload).pipe();
  }

  fetchSubChgList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditSubChngRg/fetch', payload).pipe();
  }

  saveSubChg(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditSubChng', payload).pipe();
  }

  updateSubChg(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditSubChng', payload).pipe();
  }

  getStuNotify(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StuNotification/fetch', payload).pipe();
  }

  AddStuNotify(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StuNotification', payload).pipe();
  }

  UpdtStuNotify(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/StuNotification', payload).pipe();
  }
  
  addPaymentGatewayType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/paymentGatewayType', payload).pipe();
  }
  
  updatePaymentGatewayType(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/updatePaymentGatewayType', payload).pipe();
  }
  
  getPaymentGateway(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/paymentGatewayType/fetch', payload).pipe();
  }
  
  searchPaymentGateway(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/paymentGatewayType/fetch', payload).pipe();
  }

  getSlmData(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AdSlmDetails/fetch', payload).pipe();
  }

  addSlmQuantity(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AddSlm', payload).pipe();
  }

  AddTentative(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeSchedule', payload).pipe();
  }
  getTentative(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeSchedule/fetch', payload).pipe();
  }
  AddTentativeMaster(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleMasters', payload).pipe();
  }
  getTentativeMaster(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleMasters/fetch', payload).pipe();
  }
  UpdateTentativeMaster(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/TentativeScheduleMasters', payload).pipe();
  }
  AddTentativeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleDetails', payload).pipe();
  }
  getTentativeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleDetails/fetch', payload).pipe();
  }
  getMigration(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Migration/fetch', payload).pipe();
  }

  getPassing(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Passing/fetch', payload).pipe();
  }

  getRank(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Rank/fetch', payload).pipe();
  }

  getProvisional(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Provisional/fetch', payload).pipe();
  }

  fetchCutOffCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CutoffCourse/fetch', payload).pipe();
  }

  getAllAdmitted(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/ApprAndUnPaidFee/fetch', payload).pipe();
  }

  getRegnCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/RegStuData/fetch', payload).pipe();
  }

  FeeCountData(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/FeeCountData/fetch', payload).pipe();
  }
  FetchSummaryData(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/FeeTypeCount/fetch', payload).pipe();
  }
 FeeeCountDashboardSummary(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/DashboardSummary/fetch', payload).pipe();
  }
  AddTclcDoc(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AddDocsDetails', payload).pipe();
  }

  AddTclc(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/tclcmc', payload).pipe();
  }

  AddProvisional(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Provisional', payload).pipe();
  }

  SearchTranscriptProvisional(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Provisional/fetch', payload).pipe();
  }

  updateDocumentDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/StuDocumentUpload', payload).pipe();
  }
fetchDocument(payload): Observable<any> {
      return this.http.post(this.APIService + '/document/fetchDocument', payload).pipe();
  }
  updatePRN(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/UpdatePrnNo', payload).pipe(); 
  }

  UpdateRank(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/Rank', payload).pipe();
  }

  getCertCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CertificateCourses/fetch', payload).pipe();
  }

  SaveCertificateCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CertificateCourses', payload).pipe();
  }

  updateCertificateCourse(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/CertificateCourses', payload).pipe();
  }

  DeleteCertificateCourse(payload): Observable<any> {
    console.log(payload);
    
    return this.http.delete(this.APIService + '/masters/CertificateCourses', payload).pipe();
  }

    getPracticalTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalTimeTable/fetch', payload).pipe();
  }

  savePracticalTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalTimeTable', payload).pipe();
  }

  updatePracticalTimeTable(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/PracticalTimeTable', payload).pipe();
  }

  getExamFeeSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/FeeTypeDate/fetch', payload).pipe();
  }
  fetchCollegeCount(payload): Observable<any> {
  return this.http.post(this.APIService + '/inputs/ExamFormCollegeList/fetch', payload).pipe();
}

  SendMobile(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/sendMobileOtp', payload).pipe();
  }

  VerifyMobile(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/VerifyMobOtp', payload).pipe();
  }

  VerifySuper(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CheckSuperAdmin/fetch', payload).pipe();
  }

  logSuperOTP(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/InsertOTPLogs', payload).pipe();
  }

approveRejectExamForm(payload): Observable<any> {
  return this.http.post(this.APIService + '/inputs/ExamForm/approve-reject', payload).pipe();
}

  //  chnage thr course record list
  // /api/v1/masters/evaluation-type
  // **************************************** - COLLAGE MASTER API ************************************
  // Used APis End

  downloadFile(data, filename = 'data', e) {
    this.spinner.show();
    const csvData = this.ConvertToCSV(data, e);
    const blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;',
    });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser =
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {
      // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
    this.spinner.hide();
  }

  ConvertToCSV(objArray, headerList) {
    const array =
      typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    // tslint:disable-next-line:forin
    for (const index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      // tslint:disable-next-line:forin
      for (const index in headerList) {
        const head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }
}
